export function awardResetBaseStateRequest() {
  return {
    type: '@awards/RESET_BASE_STATE_REQUEST',
  };
}

export function awardResetBaseStateSuccess() {
  return {
    type: '@awards/RESET_BASE_STATE_SUCCESS',
  };
}

export function awardResetBaseStateFailure() {
  return {
    type: '@awards/RESET_BASE_STATE_FAILURE',
  };
}
